import type { Enums } from "@msuite/utils/types";
import { icon } from "./icons";

/** Props Interface */
interface VisibilityIconProps {
	visibility: Enums<"visibility">;
}

export function VisibilityIcon({ visibility }: VisibilityIconProps) {
	let Icon = icon("Scan");
	if (visibility === "public") Icon = icon("Earth");
	if (visibility === "private") Icon = icon("Lock");
	if (visibility === "restricted") Icon = icon("LockOpen");
	return <Icon />;
}
